import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{attrs:{"small":"","color":_vm.status.color}},[_vm._v(" "+_vm._s(_vm.status.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }